// src/components/home/FinalCTA.tsx
export default function FinalCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-teal-600 to-teal-800 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <img 
          src="https://readdy.ai/api/search-image?query=abstract%20medical%20geometric%20pattern&width=1920&height=600" 
          className="w-full h-full object-cover"
          alt=""
        />
      </div>
      
      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center">
        <h2 className="text-4xl font-bold text-white mb-6">
          Ready to grow your practice?
        </h2>
        <p className="text-teal-100 text-lg mb-10 max-w-2xl mx-auto">
          Join thousands of healthcare providers who are connecting with new patients every day on Revulist. It only takes 5 minutes to get started.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/claim"
            className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-xl bg-white text-teal-700 hover:bg-teal-50 transform hover:-translate-y-1 transition-all shadow-lg"
          >
            Claim your free page
          </a>
          <a
            href="/contact"
            className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-xl border-2 border-teal-400 text-white hover:bg-teal-700 transition-colors"
          >
            Contact Sales
          </a>
        </div>
        
        <p className="mt-6 text-sm text-teal-200">
          No credit card required for basic listing • Cancel anytime
        </p>
      </div>
    </section>
  );
}